var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceDoller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Invoice",
    d: "M367-441a10,10,0,0,1,10-10,10,10,0,0,1,10,10,10,10,0,0,1-10,10A10,10,0,0,1,367-441Zm1.478,0A8.531,8.531,0,0,0,377-432.478,8.531,8.531,0,0,0,385.522-441,8.531,8.531,0,0,0,377-449.522,8.531,8.531,0,0,0,368.479-441Zm8.041,6.054v-1.462h-2.563a.739.739,0,0,1-.739-.74.739.739,0,0,1,.739-.739h2.563v-2.374h-.637a2.668,2.668,0,0,1-2.665-2.666,2.667,2.667,0,0,1,2.665-2.665h.637v-1.463a.739.739,0,0,1,.739-.739.739.739,0,0,1,.74.739v1.463h2.013a.739.739,0,0,1,.739.739.739.739,0,0,1-.739.739H378v2.374h.637a2.669,2.669,0,0,1,2.665,2.666,2.669,2.669,0,0,1-2.665,2.666H378v1.462a.739.739,0,0,1-.74.74A.739.739,0,0,1,376.52-434.946Zm1.478-2.94h.637a1.188,1.188,0,0,0,1.186-1.187,1.188,1.188,0,0,0-1.186-1.187H378Zm-3.3-5.04a1.189,1.189,0,0,0,1.187,1.187h.637v-2.374h-.637A1.189,1.189,0,0,0,374.7-442.926Z",
    transform: "translate(-367 451)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceDoller);
export default __webpack_public_path__ + "static/media/InvoiceDoller.dad4eb325ff57c130b046d0adbcf7546.svg";
export { ForwardRef as ReactComponent };